import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ROUTES } from 'src/app/constants';
import { ForgotPasswordComponent } from './forgot-password.component';

const routes: Routes = [
	{ path: ROUTES.ROOT, component: ForgotPasswordComponent }
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})

export class ForgotPasswordRoutingModule { }
